import { Center } from '@chakra-ui/react'
import ReactLottie from 'react-lottie'
const Lottie = (ReactLottie as unknown as { default: typeof ReactLottie }).default ?? ReactLottie
import animationData from '../assets/load_in_2.json'
import useWindowHeight from '../hooks/useWindowHeight'

const Loading2 = () => {
  const windowHeight = useWindowHeight()
  const defaultOptions = {
    loop: false,
    autoplay: true,

    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  return (
    <Center w="100vw" h={`${windowHeight}px`} bg="secondary.400">
      <Center flexDirection="column">
        <Lottie options={defaultOptions} height={160} width={460} speed={2} />
      </Center>
    </Center>
  )
}

export default Loading2
